// Web variant of `mapFiles.ts`. The native app copies a local `iran.mbtiles`
// and glyphs out of the bundle with react-native-fs; on the web there is no
// such local map data - the map renders from the remote tiles configured in
// `../config/tilesConfig.web.ts` (injected into the style JSON at runtime).
// This file only exists to keep the shared
// `useTileLayer` hook working (it gates the map until "the tile layer is
// ready", which on the web is immediately).
export const TILE_FILE = 'iran.mbtiles';

export const getTilePath = async (): Promise<string> => 'web://remote-tiles';
